export default __webpack_public_path__ + "static/media/im1.7476fd1f.png";